import React, { useState } from "react";

export default function TrafficTools() {
  const [keyword, setKeyword] = useState("");
  const [results, setResults] = useState([]);

  const handleSearch = (e) => {
    e.preventDefault();

    // Send to PHP backend (traffic.php)
    fetch("https://app.saravanabhava.in/backend/traffic.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ keyword }),
    })
      .then((res) => res.json())
      .then((data) => setResults(data))
      .catch((err) => console.error("Error:", err));
  };

  return (
    <div className="p-6 bg-white rounded-xl shadow-md">
      <h2 className="text-2xl font-semibold mb-4">Website Traffic Tools</h2>

      {/* Keyword Search */}
      <form onSubmit={handleSearch} className="flex gap-3 mb-5">
        <input
          type="text"
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          placeholder="Enter keyword for SEO analysis..."
          className="flex-1 border p-2 rounded-lg"
          required
        />
        <button
          type="submit"
          className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700"
        >
          Analyze
        </button>
      </form>

      {/* Results */}
      <div className="space-y-3">
        {results.length > 0 ? (
          results.map((item, index) => (
            <div
              key={index}
              className="p-3 border rounded-lg bg-gray-50 hover:bg-gray-100"
            >
              <p className="font-medium">{item.title}</p>
              <p className="text-sm text-gray-600">{item.description}</p>
              <a
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 text-sm"
              >
                View More
              </a>
            </div>
          ))
        ) : (
          <p className="text-gray-500">No results yet. Enter a keyword above.</p>
        )}
      </div>
    </div>
  );
}
